


















































import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import url from 'url';

interface KeyValue {
    key: string;
    value: string;
}

@Component
export default class RTMP extends Vue {
    private lurls: any[] = [];
    private parameters: { [key: string]: string } = {};
    private parameterBTName: string[] = [];
    private Ttl: number = 1;
    private pathname: string = '';
    private stream: string = '';
    @Prop({default: []}) private urls!: string[];
    @Prop({default: ''}) private mode!: string;
    @Prop({default: ''}) private id!: string;

    @Emit()
    private configurationChanged(newValue: string[]) {
        // dummy
    }

    @Emit()
    private typeChange(newUrl: string) {
        // dummy
    }

    @Watch('urls', { immediate: true })
    private onURLSChange(newValue: string[], oldValue: string[]) {
        if (newValue) {
            this.lurls = [];
            this.parameters = {};
            this.pathname = '';
            this.stream = '';
            let i: number = 0;

            newValue.forEach((u) => {
                const lurl: any = url.parse(u, false, false);
                this.lurls.push(lurl);

                if (this.pathname === '') {
                    this.pathname = lurl.pathname;
                    if (this.pathname.indexOf('/') !== -1 && this.pathname[this.pathname.length - 1] !== '/') {
                        this.stream = this.pathname.substring(this.pathname.lastIndexOf('/'));
                        this.pathname = this.pathname.substring(1, this.pathname.lastIndexOf('/'));
                    }

                    if (this.pathname.length > 0 && this.pathname[0] === '/') {
                        this.pathname = this.pathname.substring(1);
                    }

                    if (this.pathname.length > 0 && this.pathname[this.pathname.length - 1] === '/') {
                        this.pathname = this.pathname.substring(0, this.pathname.length - 1);
                    }

                    if (this.stream.length > 0 && this.stream[0] === '/') {
                        this.stream = this.stream.substring(1);
                    }

                    if (this.stream.length > 0 && this.stream[this.stream.length - 1] === '/') {
                        this.stream = this.stream.substring(0, this.stream.length - 1);
                    }
                }

                if (0 === i) {
                    let params: string[] = [];
                    if (lurl && lurl.query && lurl.query.indexOf('&') !== -1) {
                        params = lurl.query.split('&');
                    } else if (lurl && lurl.query && lurl.query.indexOf('=') !== -1) {
                        params.push(lurl.query);
                    }
                    params.forEach((param) => {
                        if (param.indexOf('=') !== -1) {
                            const values = param.split('=');
                            if (values.length > 1) {
                                this.parameters[values[0].toLowerCase()] = values[1];
                            } else {
                                this.parameters[values[0].toLowerCase()] = 'true';
                            }
                        } else {
                            this.parameters[param.toLowerCase()] = 'true';
                        }
                    });
                }
                {
                    let params: string[] = [];
                    if (lurl && lurl.query && lurl.query.indexOf('&') !== -1) {
                        params = lurl.query.split('&');
                    } else if (lurl && lurl.query && lurl.query.indexOf('=') !== -1) {
                        params.push(lurl.query);
                    }
                    params.forEach((param) => {
                        if (param.indexOf('=') !== -1) {
                            const values = param.split('=');
                            if (values.length > 1 && values[0].toLowerCase() === 'bt_name') {
                                this.parameterBTName[i] = values[1];
                            }
                        }
                    });
                }
                i++;
            });
            const ttl = 'ttl';
            this.Ttl = parseInt(this.parameters[ttl], 10);
        }
    }

    private remove() {
        this.configurationChanged([]);
    }

    private removeAddress(index: number) {
        Vue.delete(this.lurls, index);
    }

    private addAddress() {
        Vue.set(this.lurls, this.lurls.length, '');
    }

    private Address(index: number): string {
        if (this.lurls && this.lurls.length > 0) {
            return this.lurls[index].hostname;
        }

        return '';
    }
    private Port(index: number): number {
        if (this.lurls && this.lurls.length > 0) {
            return this.lurls[index].port;
        }

        return 0;
    }

    private AddressName(index: number): string {
        if (this.parameterBTName[index]) {
            return this.parameterBTName[index];
        }

        return '';
    }

    private get Application(): string {
        return this.pathname;
    }

    private applicationChanged(newValue: string, index: number = 0): void {
        // @ts-ignore
        Vue.set(
            this.lurls,
            index,
            url.parse(`rtmp://${this.Address(index)}:${this.Port(index)}/${newValue}/${this.stream}?${this.buildParameters(index)}`, false, false),
        );

        const conf: string[] = [];
        this.lurls.forEach((u) => conf.push(u.href));

        this.configurationChanged(conf);
    }

    private streamChanged(newValue: string, index: number = 0): void {
        // @ts-ignore
        Vue.set(
            this.lurls,
            index,
            url.parse(`rtmp://${this.Address(index)}:${this.Port(index)}/${this.pathname}/${newValue}?${this.buildParameters(index)}`, false, false),
        );

        const conf: string[] = [];
        this.lurls.forEach((u) => conf.push(u.href));

        this.configurationChanged(conf);
    }

    private get Stream(): string {
        return this.stream;
    }

    /*private get Ttl(): number {
        const ttl = 'ttl';
        if (this.parameters[ttl]) {
            console.log('this.parameters[ttl]', this.parameters[ttl]);
            return parseInt(this.parameters[ttl], 10);
        }

        return 1;
    }

    private set Ttl(value): void {
        const ttl = 'ttl';
        // @ts-ignore
        Vue.set(this.parameters, ttl, value);
        // @ts-ignore
        Vue.set(this.lurls, 0, url.parse(`udp://${this.Address}:${this.Port}?${this.buildParameters()}`));
    }*/

    private get URLS(): string[] {
        return this.lurls;
    }
    private buildParameters(index: number = 0) {
        if (index > 0) {
            if (this.parameterBTName[index] && this.parameterBTName[index] !== '') {
                return 'bt_name=' + this.parameterBTName[index];
            }
            return '';
        }

        let ret: string = '';
        Object.keys(this.parameters).forEach(
            (key) => (ret += `${key}=${this.parameters[key]}&`),
        );

        return ret.substring(0, ret.length - 1);
    }
    private addressChanged(newValue: string, index: number = 0): void {
        if (newValue.indexOf(':') !== -1 && newValue.indexOf('://') === -1) {
            if (newValue.indexOf('?') !== -1) { // also apply settings, will overwrite current settings
                this.typeChange(newValue);
                return;
            } else { // just change address and port, rest of settings are retained
                const addressAndPort = newValue.split(':');
                this.portChanged(addressAndPort[1], index);
                newValue = addressAndPort[0];
            }
        } else if (newValue.indexOf('://') !== -1 && index === 0) {
            this.typeChange(newValue);
            return;
        }
        // @ts-ignore
        Vue.set(
            this.lurls,
            index,
            url.parse(
                // @ts-ignore
                `rtmp://${newValue}:${this.Port(index)}/${this.pathname}/${this.stream}?${this.buildParameters(index)}`,
                false,
                false,
            ),
        );

        const conf: string[] = [];
        this.lurls.forEach((u) => conf.push(u.href));

        this.configurationChanged(conf);     }

    private portChanged(newValue: string, index: number = 0): void {
        // @ts-ignore
        Vue.set(
            this.lurls,
            index,
            url.parse(
                `rtmp://${this.Address(index)}:${
                    // @ts-ignore
                    newValue
                }/${this.pathname}/${this.stream}?${this.buildParameters(index)}`,
                false,
                false,
            ),
        );

        const conf: string[] = [];
        this.lurls.forEach((u) => conf.push(u.href));

        this.configurationChanged(conf);
    }

    private ttlChanged(newValue: string, index: number = 0): void {
        const ttl = 'ttl';
        // @ts-ignore
        Vue.set(this.parameters, ttl, newValue);
        // @ts-ignore
        Vue.set(
            this.lurls,
            index,
            url.parse(`rtmp://${this.Address(index)}:${this.Port(index)}/${this.pathname}/${this.stream}?${this.buildParameters(index)}`, false, false),
        );

        const conf: string[] = [];
        this.lurls.forEach((u) => conf.push(u.href));

        this.configurationChanged(conf);
    }

    private parameterChanged(newValue: string, parameter: string, index: number = 0) {
        if (index > 0) {
            Vue.set(this.parameterBTName, index, newValue);
        } else {
            if (parameter === 'bt_name' && newValue === '') {
                Vue.delete(this.parameters, parameter);
            } else {
                Vue.set(this.parameters, parameter, newValue);
            }
        }

        // @ts-ignore
        Vue.set(
            this.lurls,
            index,
            url.parse(`rtmp://${this.Address(index)}:${this.Port(index)}/${this.pathname}/${this.stream}?${this.buildParameters(index)}`, false, false),
        );

        const conf: string[] = [];
        this.lurls.forEach((u) => conf.push(u.href));

        this.configurationChanged(conf);
    }
}
